import { z } from 'zod';
import { Channel } from '.';

export const LotChannelSchema = {
  metricsUpdated: z.object({
    productCost: z.number().default(0),
    arExpenses: z.number().default(0),
    apExpenses: z.number().default(0),
    totalCost: z.number().default(0),
    totalRevenue: z.number().default(0),
    realizedRevenue: z.number().default(0),
    grossProfit: z.number().default(0),
    netProfit: z.number().default(0),
    grossProfitMargin: z.number().nullable().default(0),
    netProfitMargin: z.number().default(0),
    returnOnInvestment: z.number().default(0),
    unitsSold: z.number().default(0),
    unitsRemaining: z.number().default(0),
    daysToSell: z.number().default(0),
    unitsOrdered: z.number().default(0),
    weightOrdered: z.number().default(0),
    palletsOrdered: z.number().default(0),
    unitsReceived: z.number().default(0),
    weightReceived: z.number().default(0),
    palletsReceived: z.number().default(0),
  }),
} as const;

export const LotChannel: Channel<number, typeof LotChannelSchema> = {
  getChannelId: (id) => `lot:${id}`,
  topics: { metricsUpdated: 'metricsUpdated' },
  schemas: LotChannelSchema,
};
